import {useDispatch, useSelector} from "react-redux";
import {decreaseCartQuantity, increaseCartQuantity, removeFromCart} from "../redux/cart/actions";
import {decreaseProductQuantity, increaseProductQuantity, restoreProductQuantity} from "../redux/product/actions";

export default function CartItem({data}) {
    const dispatch = useDispatch();
    
    const increaseQuantityHandler = () => {
        dispatch(increaseCartQuantity(data.id));
        dispatch(decreaseProductQuantity(data.id));
    }

    const decreaseQuantityHandler = () => {
        dispatch(increaseProductQuantity(data.id));
        dispatch(decreaseCartQuantity(data.id));
    }
    
    const disableIncrement = data.originQuantity <= 0;
    const disableDecrement = data.quantity <= 0;
    
    const handleRemoveItem = () => {
        dispatch(removeFromCart(data.id));
        dispatch(restoreProductQuantity(data.id, data.quantity));
    }

    return (
        <div className="cartCard">
            <div className="flex items-center col-span-6 space-x-6">
                {/* <!-- cart image --> */}
                <img
                    className="lws-cartImage"
                    src={data.imageUrl}
                    alt="product"
                />
                {/* <!-- cart item info --> */}
                <div className="space-y-2">
                    <h4 className="lws-cartName">
                        {data.name}
                    </h4>
                    <p className="lws-cartCategory">{data.category}</p>
                    <p>
                        BDT <span className="lws-cartPrice">{data.price}</span>
                    </p>
                </div>
            </div>
            <div className="flex items-center justify-center col-span-4 mt-4 space-x-8 md:mt-0">
                {/* <!-- amount buttons --> */}
                <div className="flex items-center space-x-4">
                    <button disabled={disableIncrement} onClick={increaseQuantityHandler} className="lws-incrementQuantity">
                        <i className="text-lg fa-solid fa-plus"></i>
                    </button>
                    <span className="lws-cartQuantity">{data.quantity}</span>
                    <button disabled={disableDecrement} onClick={decreaseQuantityHandler} className="lws-decrementQuantity">
                        <i className="text-lg fa-solid fa-minus"></i>
                    </button>
                </div>
                {/* <!-- price --> */}
                <p className="text-lg font-bold">
                    BDT <span className="lws-calculatedPrice">{data.price * data.quantity}</span>
                </p>
            </div>
            {/* <!-- delete button --> */}
            <div className="flex items-center justify-center col-span-2 mt-4 md:justify-end md:mt-0">
                <button onClick={handleRemoveItem} className="lws-removeFromCart">
                    <i className="text-lg text-red-400 fa-solid fa-trash"></i>
                </button>
            </div>
        </div>
    );
}